import { createUpsell } from '../upsell';
export const mCu5sP = createUpsell({
    id: 'mCu5sP',
    desc: `Upsell sequence MuscleCharge - US`,
    seq: [
        {
            id: 'upsell-coach',
            onPurchase: [
                {
                    upsellPhysical: ['upsell-supplements'],
                },
                'upsell-meal-plan-supplements-guide',
            ],
            onDecline: [
                'upsell-12-month-muscle-charge',
                {
                    upsellPhysical: ['upsell-supplements'],
                },
                'upsell-chair-workout-six-pack',
                'upsell-meal-plan-supplements-guide',
            ],
        },
    ],
});
